import React, { useState } from "react";
import { Icon } from "@iconify/react";
import searchOutlined from "@iconify/icons-ant-design/search-outlined";
import LayoutDashboard from "../layout/LayoutDashboard";
import BannerOne from "../assets/images/banner/BANNER_1.jpg";
import BannerThree from "../assets/images/banner/BANNER_3.jpg";
import BannerFour from "../assets/images/banner/BANNER_4.jpg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const Banner = () => {
  const [toggleDeleteBtnIndex, setToggleDeleteBtnIndex] = useState(null);

  const toggleDelete = (deleteIndex) => {
    if (toggleDeleteBtnIndex === deleteIndex) setToggleDeleteBtnIndex(null);
    else setToggleDeleteBtnIndex(deleteIndex);
  };

  return (
    <>
      <LayoutDashboard>
        <section className="ml-4 w-full">
          <div className="md-flex">
            <div className="bg-white">
              <div class="mb-4">
                <div className="flex align-middle rounded-tl-lg rounded-tr-lg w-full py-4 overflow-hidden bg-white shadow-lg px-12">
                  <div class="flex">
                    <input
                      class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                      type="text"
                      placeholder="Pencarian"
                      aria-label="Full name"
                    />
                    <button className="bg-green-100 text-white font-bold py-2 px-4 rounded">
                      <Icon
                        icon={searchOutlined}
                        className="text-2xl text-white"
                      />
                    </button>
                  </div>
                  
                  <button className="bg-orange-500 text-white font-bold py-2 px-4 rounded ml-auto">
                  <Link to="/create-banner">
                    + Tambah Banner
                    </Link>
                  </button>
                  
                </div>
              </div>
            </div>
          </div>
          <div className="md-flex">
            <div className="bg-white">
              <div className="py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 pr-10 lg:px-8">
                <div className="align-middle rounded-tl-lg rounded-tr-lg inline-block w-full py-4 overflow-hidden bg-white shadow-lg px-12"></div>
                <div className="align-middle inline-block w-full shadow overflow-hidden bg-white shadow-dashboard px-8 pt-3 rounded-bl-lg rounded-br-lg">
                  <table className="w-full">
                    <thead>
                      <tr>
                        <th className="bg-gray-300 px-8 py-4  border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Banner
                        </th>
                        <th className="bg-gray-300 px-8 py-4  border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Judul
                        </th>
                        <th className="bg-gray-300 px-8 py-4  border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Mulai iklan
                        </th>
                        <th className="bg-gray-300 px-8 py-4  border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Akhir iklan
                        </th>
                        <th className="bg-gray-300 px-8 py-4  border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Area
                        </th>
                        <th className="bg-gray-300 px-8 py-4  border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Status
                        </th>
                        <th className="bg-gray-300 px-8 py-4  border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Tindakan
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white">
                      <tr>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="flex items-center">
                            <div>
                              <div className="text-sm leading-5 text-gray-800">
                                <img
                                  src={BannerOne}
                                  className="h-40 mr-4 rounded"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="text-sm leading-5 text-gray-600">
                            Promosi gratis ongkir
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          20 Okt 2020
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          Rp 10.000
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          20 Okt 2020
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500 text-gray-600 text-sm leading-5">
                          <span class="relative inline-block px-3 py-1 font-semibold text-gray-100 leading-tight">
                            <span
                              aria-hidden="true"
                              class="absolute inset-0 bg-green-100 rounded"
                            ></span>
                            <span class="relative text-xs">Aktif</span>
                          </span>
                        </td>
                        <th className="px-6 py-4 whitespace-no-wrap text-right  border-gray-500 text-sm leading-5">
                          <td className="  px-6 py-4 text-left leading-4 text-gray-600 tracking-wider ">
                            <div className="flex w-full items-center justify-center">
                              <button
                                className="mx-1"
                                onClick={() => {
                                  toggleDelete(1);
                                }}
                              >
                                <img
                                  src="/assets/icon/trash-can.svg"
                                  className="h-5 rounded"
                                  alt=""
                                />
                              </button>
                              <hr className="mx-1 border-r border-gray-300 h-5" />
                              <button className="mx-1">
                                <Link to="/create-banner">
                                <img
                                  src="/assets/icon/bxs-pencil.svg"
                                  className="h-5"
                                  alt=""
                                />
                                </Link>
                              </button>
                              {toggleDeleteBtnIndex === 1 && (
                                <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                                  <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                                    <div
                                      className="py-1"
                                      role="menu"
                                      aria-orientation="vertical"
                                      aria-labelledby="options-menu"
                                    >
                                      <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                                        <p className="text-sm font-semibold">
                                          Yakin Ingin menghapus banner ini?
                                        </p>
                                        <div className="flex ml-auto mt-6">
                                          <button
                                            className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                            onClick={() => {
                                              toggleDelete(1);
                                            }}
                                          >
                                            Tidak
                                          </button>
                                          <button
                                            className="text-sm text-white bg-green-700 border border-bg-green-700 px-3 py-1 rounded"
                                            onClick={() => {
                                              toggleDelete(1);
                                            }}
                                          >
                                            Ya
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                        </th>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="flex items-center">
                            <div>
                              <div className="text-sm leading-5 text-gray-800">
                                <img
                                  src={BannerThree}
                                  className="h-40 mr-4 rounded"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="text-sm leading-5 text-gray-600">
                            Promosi gratis ongkir
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          20 Okt 2020
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          Rp 10.000
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          20 Okt 2020
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500 text-gray-600 text-sm leading-5">
                          <span class="relative inline-block px-3 py-1 font-semibold text-gray-100 leading-tight">
                            <span
                              aria-hidden="true"
                              class="absolute inset-0 bg-green-100 rounded"
                            ></span>
                            <span class="relative text-xs">Aktif</span>
                          </span>
                        </td>
                        <th className="px-6 py-4 whitespace-no-wrap text-right  border-gray-500 text-sm leading-5">
                          <td className="  px-6 py-4 text-left leading-4 text-gray-600 tracking-wider ">
                            <div className="flex w-full items-center justify-center">
                              <button className="mx-1" onClick={() => {
                                  toggleDelete(2);
                                }}>
                                <img
                                  src="/assets/icon/trash-can.svg"
                                  className="h-5"
                                  alt=""
                                />
                              </button>
                              <hr className="mx-1 border-r border-gray-300 h-5" />
                              <button className="mx-1">
                              <Link to="/create-banner">
                                <img
                                  src="/assets/icon/bxs-pencil.svg"
                                  className="h-5"
                                  alt=""
                                />
                                </Link>
                              </button>
                              {toggleDeleteBtnIndex === 2 && (
                                <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                                  <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                                    <div
                                      className="py-1"
                                      role="menu"
                                      aria-orientation="vertical"
                                      aria-labelledby="options-menu"
                                    >
                                      <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                                        <p className="text-sm font-semibold">
                                          Yakin Ingin menghapus banner ini?
                                        </p>
                                        <div className="flex ml-auto mt-6">
                                          <button
                                            className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                            onClick={() => {
                                              toggleDelete(2);
                                            }}
                                          >
                                            Tidak
                                          </button>
                                          <button
                                            className="text-sm text-white bg-green-700 border border-bg-green-700 px-3 py-1 rounded"
                                            onClick={() => {
                                              toggleDelete(2);
                                            }}
                                          >
                                            Ya
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                        </th>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="flex items-center">
                            <div>
                              <div className="text-sm leading-5 text-gray-800">
                                <img
                                  src={BannerFour}
                                  className="h-40 mr-4 rounded"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                          <div className="text-sm leading-5 text-gray-600">
                            Promosi gratis ongkir
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          20 Okt 2020
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          Rp 10.000
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                          20 Okt 2020
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap  border-gray-500 text-gray-600 text-sm leading-5">
                          <span class="relative inline-block px-3 py-1 font-semibold text-gray-100 leading-tight">
                            <span
                              aria-hidden="true"
                              class="absolute inset-0 bg-green-100 rounded"
                            ></span>
                            <span class="relative text-xs">Aktif</span>
                          </span>
                        </td>
                        <th className="px-6 py-4 whitespace-no-wrap text-right  border-gray-500 text-sm leading-5">
                          <td className="  px-6 py-4 text-left leading-4 text-gray-600 tracking-wider ">
                            <div className="flex w-full items-center justify-center">
                              <button className="mx-1" onClick={() => {
                                  toggleDelete(3);
                                }}>
                                <img
                                  src="/assets/icon/trash-can.svg"
                                  className="h-5"
                                  alt=""
                                />
                              </button>
                              <hr className="mx-1 border-r border-gray-300 h-5" />
                              <button className="mx-1">
                              <Link to="/create-banner">
                                <img
                                  src="/assets/icon/bxs-pencil.svg"
                                  className="h-5"
                                  alt=""
                                />
                                </Link>
                              </button>
                              {toggleDeleteBtnIndex ===3 && (
                                <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                                  <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                                    <div
                                      className="py-1"
                                      role="menu"
                                      aria-orientation="vertical"
                                      aria-labelledby="options-menu"
                                    >
                                      <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                                        <p className="text-sm font-semibold">
                                          Yakin Ingin menghapus banner ini?
                                        </p>
                                        <div className="flex ml-auto mt-6">
                                          <button
                                            className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                            onClick={() => {
                                              toggleDelete(3);
                                            }}
                                          >
                                            Tidak
                                          </button>
                                          <button
                                            className="text-sm text-white bg-green-700 border border-bg-green-700 px-3 py-1 rounded"
                                            onClick={() => {
                                              toggleDelete(3);
                                            }}
                                          >
                                            Ya
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                        </th>
                      </tr>
                    </tbody>
                  </table>
                  <div className="sm:flex-1 sm:flex sm:items-center sm:justify-between mt-4 work-sans float-right">
                    <div>
                      <nav className="relative z-0 inline-flex shadow-sm">
                        <div>
                          <a
                            href="/"
                            className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
                            aria-label="Previous"
                          >
                            Sebelumnya
                          </a>
                        </div>
                        <div>
                          <a
                            href="/"
                            className="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-green-700 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-tertiary active:text-gray-700 transition ease-in-out duration-150 hover:bg-tertiary"
                          >
                            1
                          </a>
                          <a
                            href="/"
                            className="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-green-600 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-tertiary active:text-gray-700 transition ease-in-out duration-150 hover:bg-tertiary"
                          >
                            2
                          </a>
                          <a
                            href="/"
                            className="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-green-600 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-tertiary active:text-gray-700 transition ease-in-out duration-150 hover:bg-tertiary"
                          >
                            3
                          </a>
                        </div>
                        <div>
                          <a
                            href="/"
                            className="-ml-px relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
                            aria-label="Next"
                          >
                            Selanjutnya
                          </a>
                        </div>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </LayoutDashboard>
    </>
  );
};

export default Banner;
